module.exports = __webpack_public_path__ + "static/media/cabin-filter-change-red.3a41e144.svg";